import { ERROR_CODE as n } from "../../constants/error.js";
import { CustomError as s } from "../../errors/customError.js";
import * as C from "ramda";
import { createContext as c, useContext as x } from "react";
const d = (t, r) => {
  const o = c(r);
  o.displayName = `${t}Context`;
  const i = () => {
    const e = x(o);
    if (e === void 0 && C.isNil(r))
      throw new s(
        `use${t}Context has to be inside ${t}Provider`,
        n.GENERAL.USE_CONTEXT_WITHOUT_PROVIDER
      );
    return e;
  };
  return [o.Provider, i];
};
export {
  d as createStrictContext
};
//# sourceMappingURL=createStrictContext.js.map
